import React from "react";

const Banner = () => {
  return (
    <div className="bg-[url('/src/common/assets/images/membershipBanner.png')] min-h-[676px] bg-no-repeat bg-cover pt-[246px] pl-[125px]">
      <h1 className="font-semibold italic text-[70px] text-white">
        Get a Membership Now
      </h1>
      <button className="bg-white text-black font-light py-2 px-8">
        Get Started
      </button>
    </div>
  );
};

export default Banner;
